import { hasToken } from './guard.ts';
import LayourGeneralMinimum from '@/layout/generalMinimum'
import NewCheckout from '@/views/newCheckout/newCheckout.vue'

import Error404 from '@/views/error404/error404.vue'
import ProfileEdit from '@/views/profile-edit/profile-edit.vue'
import Profile from '@/views/profile/profile.vue'
import Referred from '@/views/referred/referred.vue'
import History from '@/views/history/history.vue'
import PaymentMethod from '@/views/payment-method/payment-method.vue'
import PseConfirmation from '@/views/pseConfirmation/pseConfirmation.vue'
import PaymentLinkConfirmation from '@/views/paymentLinkConfirmation/paymentLinkConfirmation.vue'
import Tracker from '@/views/tracker/tracker.vue'
import store from "@/store/store";
import { cityParser } from '@/plugins/city_parser'

export default [
  // {
  //   path: '/',
  //   name: 'root'
  // },
  {
    path: "",
    name: "root",
    component: LayourGeneralMinimum,
    redirect: () => {
      return { name: "featuredProducts" };
    }
  },
  {
    path: "/historia",
    component: History,
    name: "history_orders",
    beforeEnter: hasToken
  },
  {
    path: "/pse_confirmation",
    component: PseConfirmation,
    name: "pse-confirmation"
  },
  {
    path: "/payment_link_confirmation",
    component: PaymentLinkConfirmation,
    name: "payment-link-confirmation"
  },
  {
    path: "/checkout",
    component: NewCheckout,
    name: "checkout"
  },
  {
    path: "/tracker/:order_id",
    component: Tracker,
    name: "tracker",
    beforeEnter: hasToken
  },
  {
    path: "/perfil",
    component: Profile,
    name: "profile",
    beforeEnter: hasToken
  },
  {
    path: "/perfil-editar",
    component: ProfileEdit,
    name: "profile-edit",
    beforeEnter: hasToken
  },
  {
    path: "/referidos",
    component: Referred,
    name: "referred"
  },
  {
    path: "/metodos-pago",
    component: PaymentMethod,
    name: "paymentmethod",
    beforeEnter: hasToken
  },
  {
    path: "/error",
    component: Error404,
    name: "error-404"
  },
  {
    path: "/mi-menu",
    redirect: () => {
      return { name: 'subscription_home' };
    }
  }
];
